import { get_settlements } from "../creditSettlement/actions";
import {
  get_applications_for_account,
  get_credit_applications,
} from "../applications/actions";

export const USER_CREDIT_HISTORY_GET_REQUEST =
  "USER_CREDIT_HISTORY_GET_REQUEST";
export const USER_CREDIT_HISTORY_APPLICATION_GET_SUCCESS =
  "USER_CREDIT_HISTORY_APPLICATION_GET_SUCCESS";
export const USER_CREDIT_HISTORY_LOAN_GET_SUCCESS =
  "USER_CREDIT_HISTORY_LOAN_GET_SUCCESS";
export const USER_CREDIT_HISTORY_CREDIT_APPLICATION_GET_SUCCESS =
  "USER_CREDIT_HISTORY_CREDIT_APPLICATION_GET_SUCCESS";
export const USER_CREDIT_HISTORY_GET_ERROR = "USER_CREDIT_HISTORY_GET_ERROR";

export const get_credit_history_for_account = (accountId) => {
  return (dispatch) => {
    dispatch({
      type: USER_CREDIT_HISTORY_GET_REQUEST,
    });

    dispatch(
      get_settlements(accountId, null, null, null, null, null, [
        "",
        {
          method: get_credit_history_loan_for_account_success.bind(
            this,
            accountId,
          ),
        },
        USER_CREDIT_HISTORY_GET_ERROR,
      ]),
    );
  };
};

const get_credit_history_loan_for_account_success = (accountId, response) => {
  return (dispatch) => {
    dispatch({
      type: USER_CREDIT_HISTORY_LOAN_GET_SUCCESS,
      dataSent: { accountId },
      response,
    });

    dispatch(
      get_applications_for_account(accountId, [
        "",
        {
          method: get_credit_history_application_for_account_success.bind(
            this,
            accountId,
          ),
        },
        USER_CREDIT_HISTORY_GET_ERROR,
      ]),
    );
    dispatch(
      get_credit_applications(accountId, null, null, null, null, [
        "",
        {
          method:
            get_credit_history_credit_application_for_account_success.bind(
              this,
              accountId,
            ),
        },
        USER_CREDIT_HISTORY_GET_ERROR,
      ]),
    );
  };
};

const get_credit_history_application_for_account_success = (
  accountId,
  response,
) => {
  return (dispatch) => {
    dispatch({
      type: USER_CREDIT_HISTORY_APPLICATION_GET_SUCCESS,
      dataSent: { accountId },
      response,
    });
  };
};

const get_credit_history_credit_application_for_account_success = (
  accountId,
  response,
) => {
  return (dispatch) => {
    dispatch({
      type: USER_CREDIT_HISTORY_CREDIT_APPLICATION_GET_SUCCESS,
      dataSent: { accountId },
      response,
    });
  };
};
